import { javascript } from '@codemirror/lang-javascript';
import { cpp } from '@codemirror/lang-cpp';
import { css } from '@codemirror/lang-css';
import { java } from '@codemirror/lang-java';
import { php } from '@codemirror/lang-php';
import { python } from '@codemirror/lang-python';
import { html } from '@codemirror/lang-html';
import { sql } from '@codemirror/lang-sql';
import { json } from '@codemirror/lang-json';
import { rust } from '@codemirror/lang-rust';
import { xml } from '@codemirror/lang-xml';
import { clojure } from '@nextjournal/lang-clojure';
import { csharp } from '@replit/codemirror-lang-csharp';
import { CONVERTIBLE_LANGUAGES } from 'src/constants';
import { ProgrammingLanguage } from 'src/types';
import { PROGRAMMING_LANGUAGES } from 'src/constants';

const actualNewline = `
`;

// TODO(olha): WIP Editor do we need to call it for text?
export const cleanContent = (content: string): string => {
  return content ? content.replace(/\\n/g, actualNewline) : '';
};

// TODO(olha): WIP Editor use enum
export const getLanguageExtension = (language: string) => {
  switch (language) {
    case 'javascript':
    case 'vue':
    case 'jsx':
      return javascript({ jsx: true, typescript: false });
    case 'typescript':
      return javascript({ jsx: true, typescript: true });
    case 'cpp':
      return cpp();
    case 'java':
      return java();
    case 'php':
      return php();
    case 'python':
      return python();
    case 'html':
      return html();
    case 'sql':
      return sql();
    case 'json':
      return json();
    case 'rust':
      return rust();
    case 'xml':
      return xml();
    case 'clojure':
      return clojure();
    case 'csharp':
      return csharp();
    case 'css':
      return css();
    case 'scss':
      return css();
    default:
      return [];
  }
};

export const getLanguageKey = (
  language?: ProgrammingLanguage | string,
): ProgrammingLanguage => {
  if (language === 'vue' || language === 'jsx') {
    return 'javascript';
  }

  return getLanguageInfoFromList(language)?.language || 'other';
};

export const getLanguageInfoFromList = (
  language?: string,
):
  | {
      language: ProgrammingLanguage;
      label: string;
    }
  | undefined =>
  PROGRAMMING_LANGUAGES.find((value) => value.language === language);

export const getLanguageLabel = (language: ProgrammingLanguage): string => {
  const languageInfo = getLanguageInfoFromList(language);

  return languageInfo ? languageInfo.label : 'Other';
};

export const getCodeEditorChangeLanguagePrompt = (
  from: ProgrammingLanguage,
  to: ProgrammingLanguage,
) => `
  Convert the following ${from} code to ${to} while preserving its logic, structure, and functionality.
  Ensure that the ${to} code follows best practices and idiomatic conventions.
  If necessary, replace ${from}-specific functions with their closest ${to} equivalents.
`;

export function canConvertLanguages(
  from: ProgrammingLanguage,
  to: ProgrammingLanguage,
): boolean {
  if (from === to) {
    return true;
  }

  return !!CONVERTIBLE_LANGUAGES[from]?.includes(to);
}
